export default __webpack_public_path__ + "static/media/mansion-review.aad7ef4d.JPG";